import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
    actionButton: {
        backgroundColor: '#eeeeee',
        disabledBackgroundColor: '#bbbbbb',
        disabledIconColor: '#999999'
    },
    baseline: {
        background1: '#DDDDDD',
        background2: '#CCCCCC'
    },
    palette: {
        type: 'light',
        iconColor: '#666666',
        backgroundColor: '#ffffff',
        primary: {
            main: '#404040'
        },
        secondary: {
            main: '#0076bb'
        },
        text: {
            primary: '#000000',
            secondary: '#404040',
            disabled: '#808080'
        }
    },
    overrides: {
        MuiList: {
            root: {
                backgroundColor: '#EEEEEE'
            }
        },
        MuiGrid: {
            root: {
                color: '#000000'
            }
        },
        MuiTab: {
            textColorInherit: {
                color: '#000000'
            }
        },
        MuiSwitch: {
            colorSecondary: {
                "&$checked": {
                    color: 'blue'
                }
            },
            track: {
                // Controls default (unchecked) color for the track
                opacity: 0.2,
                backgroundColor: "#808080",
                "$checked$checked + &": {
                  // Controls checked color for the track
                  opacity: 0.7,
                  backgroundColor: "#808080"
                }
              }
        },
        MuiCssBaseline: {
            '@global': {
                  html: {
                    backgroundColor: '#eeeeee',
                    //WebkitFontSmoothing: 'auto',
                  },
            },
        },
        MuiButton: {
            textPrimary: {
                color: '#000000'
            }
        },
        MuiDialog: {
            paper: {
                margin: 10
            }
        },
        MuiDrawer: {
            paper: {
                backgroundColor: '#EEEEEE'
            }
        }
    }
});
export default theme;